import React, { useEffect } from "react";
import { useTransactionFilters } from "./hooks/useTransactionFilters";
import { useTransactionData } from "./hooks/useTransactionData";
import { useReassignTransactionModal } from "./hooks/useReassignTransactionModal";
import { useTransactionDetailsModal } from "./hooks/useTransactionDetailsModal";
import { usePdfExport } from "./hooks/usePdfExport";
import { useUserRole } from "./hooks/useUserRole";
import { useMerchantOptions } from "./hooks/useMerchantOptions";
import TransactionsPageContent from "./TransactionsPageContent";

const TransactionsPage = () => {
  const { isSuperAdmin } = useUserRole();
  const {
    filters,
    pagination,
    apiFilters,
    managementApiFilters,
    setPagination,
    resetPagination,
    searchQuery,
    dateRange,
    serviceFilter,
    merchantId,
    setSearchQuery,
    setDateRange,
    setServiceFilter,
    setMerchantId,
  } = useTransactionFilters(isSuperAdmin);

  const {
    options: merchantOptions,
    isLoading: merchantOptionsLoading,
    isError: isMerchantOptionsError,
  } = useMerchantOptions(isSuperAdmin);

  const {
    transactions,
    totalElements,
    totalPages,
    isLoading,
    isFetching,
    isError,
    refetch,
    initialLoadDone,
    noTransactions,
  } = useTransactionData({
    apiFilters,
    managementApiFilters,
    isSuperAdmin,
  });

  const detailsModal = useTransactionDetailsModal();
  const reassignModal = useReassignTransactionModal(merchantOptions);

  const { handleExport: handleExportPdf, isExporting } = usePdfExport({
    isSuperAdmin,
    searchQuery,
    dateRange,
    serviceCodes: apiFilters.serviceCodes,
    merchantId,
    page: pagination.pageIndex,
    size: pagination.pageSize,
  });
  useEffect(() => {
    resetPagination();
  }, [
    filters.searchQuery,
    filters.dateRange.startDate,
    filters.dateRange.endDate,
    filters.serviceFilter,
    filters.merchantId,
    isSuperAdmin,
    resetPagination,
  ]);

  const filterProps = {
    searchQuery,
    setSearchQuery,
    dateRange,
    setDateRange,
    serviceFilter,
    setServiceFilter,
    merchantId,
    setMerchantId,
  };

  const dataProps = {
    transactions,
    totalElements,
    totalPages,
    noTransactions,
    isLoading,
    isFetching,
    isError,
    onRetry: refetch,
    initialLoadDone,
  };

  const paginationProps = {
    pagination,
    setPagination,
  };

  const merchantProps = {
    merchantOptions,
    merchantOptionsLoading,
    isMerchantOptionsError,
  };

  const exportProps = {
    handleExportPdf,
    isExporting,
  };

  const modals = {
    details: detailsModal,
    reassign: reassignModal,
  };

  return (
    <TransactionsPageContent
      filters={filterProps}
      data={dataProps}
      paginationProps={paginationProps}
      merchants={merchantProps}
      exportProps={exportProps}
      modals={modals}
      isSuperAdmin={isSuperAdmin}
    />
  );
};

export default TransactionsPage;
